import { graphql } from 'react-relay';
import {
    ORDER_BY_NEWEST,
    ORDER_BY_HIGHEST,
    ORDER_BY_LOWEST,
    ORDER_BY_IMAGES,
    ORDER_BY_RATING_1,
    ORDER_BY_RATING_2,
    ORDER_BY_RATING_3,
    ORDER_BY_RATING_4,
    ORDER_BY_RATING_5,
    DEFAULT_RATING_FILTER,
    DEFAULT_DESKTOP_REVIEWS_PAGE_SIZE,
    type OrderBy as OrderByType,
    type RatingFilter,
} from './constants.ts';

import { type SellerReviewsModalQuery$variables } from './__generated__/SellerReviewsModalQuery.graphql.ts';

export type OrderBy = OrderByType;

export { DEFAULT_RATING_FILTER, type RatingFilter };

export const DEFAULT_SORT = ORDER_BY_NEWEST;

export const getSortOrders = (
    sortVal: string
): {
    [ORDER_BY_NEWEST]: boolean;
    [ORDER_BY_HIGHEST]: boolean;
    [ORDER_BY_LOWEST]: boolean;
    [ORDER_BY_IMAGES]: boolean;
} => ({
    [ORDER_BY_NEWEST]: sortVal === ORDER_BY_NEWEST,
    [ORDER_BY_HIGHEST]: sortVal === ORDER_BY_HIGHEST,
    [ORDER_BY_LOWEST]: sortVal === ORDER_BY_LOWEST,
    [ORDER_BY_IMAGES]: sortVal === ORDER_BY_IMAGES,
});

export const getReviewRating = (ratingFilter: RatingFilter): { reviewRating: number } => {
    switch (ratingFilter) {
        case ORDER_BY_RATING_1:
            return { reviewRating: 1 };
        case ORDER_BY_RATING_2:
            return { reviewRating: 2 };
        case ORDER_BY_RATING_3:
            return { reviewRating: 3 };
        case ORDER_BY_RATING_4:
            return { reviewRating: 4 };
        case ORDER_BY_RATING_5:
            return { reviewRating: 5 };
        default:
            return { reviewRating: 0 };
    }
};

export const initialVars: SellerReviewsModalQuery$variables = {
    sellerId: '',
    isMobileScrollContainer: false,
    ...getSortOrders(DEFAULT_SORT),
    ...getReviewRating(DEFAULT_RATING_FILTER),
    page: 1,
    count: DEFAULT_DESKTOP_REVIEWS_PAGE_SIZE,
};

export const Query = graphql`
    query SellerReviewsModalQuery(
        $sellerId: String!
        $isMobileScrollContainer: Boolean!
        $orderByNewest: Boolean!
        $orderByHighest: Boolean!
        $orderByLowest: Boolean!
        $orderByImages: Boolean!
        $page: Int!
        $reviewRating: Int!
        $count: Int!
    ) {
        viewer {
            ...SellerReviewsModalContent_viewer
                @arguments(count: $count)
                @skip(if: $isMobileScrollContainer)
            ...SellerReviewsMobileModalContent_viewer
                @arguments(count: $count)
                @include(if: $isMobileScrollContainer)
        }
    }
`;
